const Portfolio = () => {
	return (
		<div className="portfolio">
			<p className="portfolio_text">a.k.a. projects and half-baked ideas</p>
			<h2 className="portfolio_heading">Still fleshing this out - come back later!</h2>
			
		</div>
	);
}

export default Portfolio;